<div class="modal-content">
  <div class="modal-body p-0">
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-0 shadow-none">
          <div class="card-body p-0">
            <div [ngClass]="{'loading': resultsLoading}" class="search-input-container">
              <input #searchInput
                     (click)="resetScroll()"
                     (input)="onSearchChange($event)"
                     class="form-control form-control-lg search-input"
                     placeholder="{{ 'search.type_in_searched_text' | translate }}"
                     type="text">
            </div>
            <div *ngIf="results$ | async as results" class="results" id="results-list">
              <div *ngFor="let result of results | keyvalue: originalOrder" class="result">
                <div class="result-category">
                  {{ 'permissions.' + result.key | lowercase | translate }}
                </div>
                <div class="result-body">
                  <div (click)="redirectToResult(item)"
                       *ngFor="let item of result.value"
                       [ngClass]="{'highlighted': item.row === selectedResultRow}"
                       class="result-item"
                       id="result-{{item.row}}">
                   <span class="result-icon-box">
                      <span [class]="item.icon + ' mdi-20px'"></span>
                      <img *ngIf="item.icon_url" [height]="34" [ngSrc]="item.icon_url" [width]="34" alt="Employee avatar"/>
                   </span>
                    <div class="result-info">
                      <div class="result-info-content">
                        <span>{{ item.label }}</span>
                        <span *ngIf="item.is_archived"> 🗃 </span>
                        <div *ngIf="item.details" class="result-details">
                          <small *ngFor="let keyValue of item.details; let last = last; let first = first" class="text-muted">
                            <span *ngIf="keyValue.value">
                              {{ first ? (keyValue.key | translate) : ((keyValue.key | translate).charAt(0).toLowerCase() + (keyValue.key | translate).slice(1)) }}:
                              {{ keyValue.value }}{{ !last ? ', ' : '' }}
                            </span>
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
